export default "__VITE_ASSET__DVEGTt7Z__"